import { IEmployee } from '@cbgms/api'
import { IWorkorderClockingAction } from '@cbgms/api/modules/clocking-actions'
import { EmptyListDateTime, apiFormat } from '@cbgms/base/utils/datetime'
import moment from 'moment'

export const clockResponseToTimePerEmployee = (data: IWorkorderClockingAction[], serverTime: string, employeeUUID?: string) => {
  const perEmployee: { Employee: IEmployee; totalTime: moment.Duration; isActive: boolean; startTime: string }[] = []
  const duration = (clockOut: string, clockIn: string) =>
    moment.duration(moment(clockOut === EmptyListDateTime ? serverTime : clockOut, apiFormat.iso).diff(moment(clockIn, apiFormat.iso)))

  data.forEach(clockingAction => {
    const clockedEmployee = perEmployee.find(item =>
      employeeUUID ? employeeUUID === clockingAction.Employee.UUID : item.Employee.UUID === clockingAction.Employee.UUID
    )
    if (!clockedEmployee) {
      // new employee, create entry
      perEmployee.push({
        Employee: clockingAction.Employee,
        totalTime: duration(clockingAction.ClockingAction.ClockedOutAt, clockingAction.ClockingAction.ClockedInAt),
        isActive: false,
        startTime: serverTime
      })
    } else {
      // employee already in array, add time
      const addTime = duration(clockingAction.ClockingAction.ClockedOutAt, clockingAction.ClockingAction.ClockedInAt)
      clockedEmployee.totalTime = clockedEmployee.totalTime.add(addTime)
    }
  })

  perEmployee.forEach(employee => {
    employee.startTime = moment(employee.startTime).subtract(employee.totalTime).toISOString()
    employee.isActive = data
      .filter(item => item.Employee.UUID === employee.Employee.UUID)
      .some(clockingAction => clockingAction.ClockingAction.ClockedOutAt === EmptyListDateTime)
  })

  return perEmployee
}
